import { AnalyticsProvider } from 'shared/src/context';
import { useGetMarketAnalyticsDefaults } from '../hooks/useLogMarketAnalyticsEvent';

export const MarketAnalyticsProvider = ({
  marketId,
  children,
}: {
  marketId: number;
  children: React.ReactNode;
}) => {
  const getDefaults = useGetMarketAnalyticsDefaults(marketId);

  return (
    <AnalyticsProvider screen="MARKET" getDefaults={getDefaults}>
      {children}
    </AnalyticsProvider>
  );
};
